export default {
    //sistema
    Modulo: 225,
    //fechas
    dateformat: "dd/MM/yyyy",
    formatoFechaStandard: "DD/MM/yyyy",
    formatoFechaStandardHora: "DD/MM/yyyy h:mm:ss a",
    formatoHoras: "hh:mm:ss",
    formatoMesAno: 'MMMM yyyy',
    formatoFechaAMD: 'YYYY-MM-DD',
    anoAntiguedad: 2000,
    //Constantes para los paises de interfaz
    PaisCostaRica: "Costa Rica",
    PaisNicaragua: "Nicaragua",
    PaisGuatemala: "Guatemala",
    PaisHonduras: "Honduras",

    //Pais default
    PaisDefecto: "CR",

    tcEgresos: 4,
    tcCostos: 6,
    ncCentroCosto: 'CENTROCOSTO',
    ncCentroUtil: 'CENTROUTIL',
    ncPlantillas: 'PLANTILLAS',
    ncAsientos: 'ASIENTOS',

    //Meses del Aguinaldo
    MesIniAg: 12,
    MesFinAg: 11,

    //numero de modulos
    ModBancos: 0,
    ModCxp: 10,
    ModCxc: 20,
    ModPlan: 30,
    ModConta: 40,
    ModServer: 50,
    ModAsocia: 60,
    ModActivos: 70,
    ModSID: 80,
    ModOpera: 90,
    ModComNet: 100,
    ModFood: 110,
    ModRelj: 120,
    ModAhorro: 130,
    ModPrestamo: 140,

    //Internal ModuleName
    IntCont: "LD_CONTABILIDAD",
    IntBanc: "LD_BANCOS",
    IntCxCo: "LD_CUENTASPORCOBRAR",
    IntCxPa: "LD_CUENTASPORPAGAR",
    IntPlan: "LD_PLANILLAS",
    IntActF: "LD_ACTIVOS",
    IntServ: "LD_SERVER",
    IntRecH: "LD_RECURSOSHUMANOS",
    IntRepo: "LD_REPORTEADOR",
    IntCom6: "LD_COM_VB6",
    IntComN: "LD_COM_NET",
    IntFood: "LD_FOOD",
    IntTiCa: "LD_TIPOCAMBIO",
    IntRelj: "LD_CONTROL_RELOJ_MARCADOR",
    IntAhor: "LD_AHORRO",
    IntPres: "LD_PRESTAMO",
    IntAuto: "LD_AUTOGESTION_RH",


    //Tipo Banco
    Ban_BCR: { titulo: "Banco de Costa Rica", tipoBanco: "BCR" },
    Ban_BCRE: { titulo: "Banco de Costa Rica Empresarial", tipoBanco: "BCRE" },
    Ban_BNCR: { titulo: "Banco Nacional de Costa Rica", tipoBanco: "BNCRE" },
    Ban_Popular: { titulo: "Banco Popular", tipoBanco: "POP" },
    Ban_SanJose: { titulo: "Banco BAC", tipoBanco: "BSJ" },
    Ban_BNCRNormal: { titulo: "Banco Nacional de Costa Rica", tipoBanco: "BNCR" },
    Ban_HSBC: { titulo: "Banco HSBC", tipoBanco: "HSBC" },
    Ban_BNCRPAS: {
        titulo: "Banco Nacional de Costa Rica PAS",
        tipoBanco: "BNCRPA",
    },
    Ban_Scotiabank: { titulo: "Banco Scotiabank", tipoBanco: "SCOTIA" },
    Ban_BIND: { titulo: "Banco Industrial", tipoBanco: "BIND" },
    Ban_BPRO: { titulo: "Banco BANPRO", tipoBanco: "BPRO" },



    //lista de reportes
    Reportes: {
        Colillapago: 1,
        Resumenplanilla: 2,
        Detalleplanilla: 3,
        Salariosaplicados: 4,
        Provisionesgenerales: 5,
        Generalempleados: 6,
        Salarioempleado: 7,
        Empleadossinsalario: 8,
        Librosalarios: 9,
        Provisionesempleado: 10,
        Detalleaumentoretroactivo: 11,
        ColillapagoAdel: 12,
        Detallesadelantos: 13,
        Consultageneral: 14,
        Consultaespecifica: 15,
        Ingresosdistribuidos: 16,
        Porempleado: 17,
        Graficodepartamento: 18,
        Deduccionesnoaplicadas: 19,
        Embargosporempleado: 20,
        Colillaaguinaldo: 21,
        Aguinaldoempleado: 22,
        Acumuladodeaguinaldo: 23,
        Detallenominaanual: 24,
        D152Resumenretenciones: 25,
        RotacionPersonal: 26,
        RotacionPersonalGrafico: 27,
        Liquidaciones: 28,
        Personalizado: 29,
        AccionesPersonal: 30,
        CategoriasEmpleados: 31,
        SalariosFueraCategoria: 32,
        VacacionesPendientes: 33,
        CumpleanosDelMes: 34,
        CumpleañosHijos: 35,
        AnosDeLaborar: 36,
        ConstanciaSalarial: 37,
        ConstanciaLaboral: 38,
        Despido: 39,
        CertificadoArticulo35: 40,
        OperadoraDePensiones: 41,
        RespaldoInformacionPersonal: 42,
        SolicitudVacaciones: 43,
        ImprimeGafetes: 44,
        ConciliacionAux: 54,
        AsientosDiario: 55,
        DiarioGeneral: 56,
        AsientosDelCierre: 57,
        AsientosFinancieros: 58,
        BalanceSituacion: 59,
        BalanceComprobacion: 60,
        ImpresionDeCuentas:61,
        BalanceComprobacionEstimado: 62,
        ImpresionDeCatalogo:63,
        HistoricoSaldos: 64,
        ImpresionCentroCosto: 65,
        MovimientosSinAPlicar: 66,
        ConsolidaciondeCuentas:67,
        Comprometido: 68,
        ReportesCentroCostos: 69,
        ReportesCentroUtilidades: 70,
        BitacoraGeneral: 71,
        EstadoResultadosPresupuesto: 72,
        CierreFiscal: 73,
        BalanceSituacionPresupuesto:74,
        CentroCostosPresupuesto: 75,
        CentroUtilidadesPresupuesto: 76,

    },

    paramFilter: {
        TipoFiltro: { Codigo: 0, Nombre: 1, Empresa: 2 },
        Empresa: -1,
        Cadena: -1,
        Sucursal: -1,
        FechaDesde: new Date(1900, 1, 1),
        FechaHasta: new Date(1900, 1, 1),
        Moneda: -1,
        Provision: -1,
        Id: -1,
        Numero: "",
        Descripcion: "",
        Tipo: "",
        intTipo: -1,
        Area: -1,
        Depto: -1,
        Seccion: -1,
        Oficina: -1,
        Ingreso: -1,
        TipoDoc: -1,
        DesdeR: -1,
        HastaR: -1,
        Anno: -1,
        Dia: -1,
        Mes: -1,
        Hora: -1,
        Cedula: "",
        Nombre: "",
        Apellido1: "",
        NumNomina: -1,
        TipoPlanilla: -1,
        Module: "",
        Usuario: "",
        Empleado: -1,
        EstadoHoras: "",
        strAsientoConta: false,
        Centro_Costo: -1,
        CtaContable: -1,
        Modulo_Id: -1,
        Usuario_Id: -1,
        Menu_id: -1,
        Opcion_id: -1,
        Fecha: new Date(1900, 1, 1),
        Estado: -1,
        Cuenta: "",
        Padres: -1,
        Aplica: -1,
        EsBase: false,
        ClaseStr: "",
        SalBruto: false,
        CtaBancaria: -1,
        Poliza: -1,
        TipoColilla: "",
        Anno2: -1,
        Dia2: -1,
        Mes2: -1,
        Mensual: false,
    },



    listaDias: [
        { value: 1, label: "Lunes" },
        { value: 2, label: "Martes" },
        { value: 3, label: "Miércoles" },
        { value: 4, label: "Jueves" },
        { value: 5, label: "Viernes" },
        { value: 6, label: "Sábado" },
        { value: 7, label: "Domingo" },
    ],
    listaMeses: [
        { value: 1, label: "Enero" },
        { value: 2, label: "Febrero" },
        { value: 3, label: "Marzo" },
        { value: 4, label: "Abril" },
        { value: 5, label: "Mayo" },
        { value: 6, label: "Junio" },
        { value: 7, label: "Julio" },
        { value: 8, label: "Agosto" },
        { value: 9, label: "Setiembre" },
        { value: 10, label: "Octubre" },
        { value: 11, label: "Noviembre" },
        { value: 12, label: "Diciembre" },
    ],


    listaTipoPago: [
        { value: 0, label: "Pago en Cheque" },
        { value: 1, label: "Pago en Efectivo" },
        { value: 2, label: "Cuenta Bancaria" },
    ],
    listaBancos: [
        { value: "BCR", label: "BCR-  Banco de CR" },
        { value: "BNCRE", label: "BNCRE-Banco Nacional de CR Electrónica" },
        { value: "BNCR", label: "BNCR- Banco Nacional de CR" },
        { value: "BNCRPA", label: "BNCRPA - Banco Nacional de CR PAS" },
        { value: "BSJ", label: "BSJ-  Banco de San José" },
        { value: "POP", label: "POP-  Banco Popular" },
        { value: "HSBC", label: "HSBC- Banco HSBC" },
        { value: "SCOTIA", label: "SCOTIA- Banco Scotiabank" },
    ],
    listaBancosNI: [
        { value: "BSJ", label: "BSJ-  BAC Credomatic" },
        { value: "BPRO", label: "BPRO-  Banco Banpro" },
    ],
    listaBancosGU: [
        { value: "BACH", label: "BACH- BAC Guatemala" },
        { value: "BIND", label: "BIND- Banco Industrial" },
    ],
    listaBancosHN: [{ value: "FIC", label: "FIC-  Banco Ficohsa" }],
    listaTipoSalario: [
        { value: 1, label: "Salario Fijo" },
        { value: 2, label: "Salario Variable" },
    ],
    constTipoSalario: { SalarioFijo: 1, SalarioVariable: 2 },


    listaTipoCuentaBanco: [
        { value: 1, label: "Corriente" },
        { value: 2, label: "Ahorro" },
        { value: 3, label: "Electronica" },
        { value: 4, label: "CMB - HSBC" },
        { value: 5, label: "CDB - HSBC" },
    ],

    listaOptionsCC: [
        { value: 1, text: "Todo el centro de costo", reverso: true },
    ],

    listaOptionsCuentas: [
        { value: 1, text: "Todas", reverso: true },
        { value: 2, text: "Rango General", reverso: true },
        { value: 3, text: "Niveles de Cuentas", reverso: true },
    ],

    listaOptionsImpresion: [
        {value: 1, text: "Portrait", reverso: true},
        {value: 2, text: "Landscape", reverso: true}
    ],

    listaOptionsEstadosF: [
        {value: 1, text: "Todo el Catálogo", reverso: true},
        {value: 2, text: "Tipo de Cuenta", reverso: true}
    ],

    listaOptionsDatosRep: [
        {value: 1, text: "Saldos del Mes", reverso: true},
        {value: 2, text: "Acumulados", reverso: true}
    ],

    listaCiudades: [
        { value: "San José", label: "San José" },
        { value: "Cartago", label: "Cartago" },
        { value: "Alajuela", label: "Alajuela" },
        { value: "Heredia", label: "Heredia" },
        { value: "Puntarenas", label: "Puntarenas" },
        { value: "Limón", label: "Limón" },
        { value: "Guanacaste", label: "Guanacaste" },
    ],
    listaCiudadesNic: [
        { label: "Managua", value: "Managua" },
        { label: "Masaya", value: "Masaya" },
        { label: "Rivas", value: "Rivas" },
        { label: "Carazo", value: "Carazo" },
        { label: "Granada", value: "Granada" },
        { label: "Matagualpa", value: "Matagualpa" },
        { label: "Jinotega", value: "Jinotega" },
        { label: "Estelí", value: "Estelí" },
        { label: "Chontales", value: "Chontales" },
        { label: "Boaco", value: "Boaco" },
        { label: "Madriz", value: "Madriz" },
        { label: "Nueva Segovia", value: "Nueva Segovia" },
        { label: "Río San Juan", value: "Río San Juan" },
        { label: "León", value: "León" },
        { label: "Chinandega", value: "Chinandega" },
        { label: "Región Autónoma Sur", value: "Región Autónoma Sur" },
        { label: "Región Autónoma Norte", value: "Región Autónoma Norte" },
    ],
    listaCiudadesGT: [
        { label: "Alta Verapaz", value: "Alta Verapaz" },
        { label: "Baja Verapaz", value: "Baja Verapaz" },
        { label: "Chimaltenango", value: "Chimaltenango" },
        { label: "Chiquimula", value: "Chiquimula" },
        { label: "El Progreso", value: "El Progreso" },
        { label: "Escuintla", value: "Escuintla" },
        { label: "Guatemala", value: "Guatemala" },
        { label: "Huehuetenango", value: "Huehuetenango" },
        { label: "Izabal", value: "Izabal" },
        { label: "Jalapa", value: "Jalapa" },
        { label: "Jutiapa", value: "Jutiapa" },
        { label: "Petén", value: "Petén" },
        { label: "Quetzaltenango", value: "Quetzaltenango" },
        { label: "Quiché", value: "Quiché" },
        { label: "Retalhuleu", value: "Retalhuleu" },
        { label: "Sacateréquez", value: "Sacateréquez" },
        { label: "San Marcos", value: "San Marcos" },
        { label: "Santa Rosa", value: "Santa Rosa" },
        { label: "Sololá", value: "Sololá" },
        { label: "Suchitepéquez", value: "Suchitepéquez" },
        { label: "Totonicapán", value: "Totonicapán" },
        { label: "Zacapa", value: "Zacapa" },
    ],


    eaDigitado: 1,
    eaAprobado: 2,
    eaAplicado: 3,
    eaAnulado: 4,
    //tipos de plantilla contabilidad
    tpSimple: 1,
    tpPorcentual: 2,

    listaEstadoAsientos: [
        { value: 1, label: "Digitado" },
        { value: 2, label: "Aprobado" },
        { value: 3, label: "Aplicado" },
        { value: 4, label: "Anulado" }
    ],
    /* Constantes para el tipo de anulación de los asientos */
    anNormal: 1,
    anMovMes: 2,

    /*Tipo para los subtipo de las cuentas */
    listaSubTiposCuentasTipo: [
        { value: 0, label: "Activos" },
        { value: 1, label: "Pasivos" },
        { value: 2, label: "Patrimonio" },
        { value: 3, label: "Ingresos" },
        { value: 4, label: "Egresos" },
        { value: 5, label: "Orden" },
        { value: 6, label: "Costos" },
        { value: 7, label: "Ingresos No Deducibles" },
        { value: 8, label: "Egresos No Deducibles" },
    ],

    /* Constantes de tipos de cuentas */
    TcActivos: 0,
    TcPasivos: 1,
    TcPatrimonio: 2,
    TcIngresos: 3,
    TcEgresos: 4,
    TcOrden: 5,
    TcCostos: 6,
    TcIngNoDed: 7,
    TcGastNoDed: 8,

    /*Constantes para ordenar las cuenta segun sus tipos de cuentas*/
    OrdActivos: 0,
    OrdPasivos: 10,
    OrdPatrimonio: 20,
    OrdIngresos: 30,
    OrdIngNoDed: 32,
    OrdCostos: 40,
    OrdEgresos: 50,
    OrdGastNoDed: 52,
    OrdOrden: 60,

    /*Constantes para el orden para el reporte fiscal*/
    OrdFisActivos: 0,
    OrdFisPasivos: 10,
    OrdFisPatrimonio: 20,
    OrdFisIngresos: 30,
    OrdFisCostos: 40,
    OrdFisEgresos: 50,
    OrdFisIngNoDed: 60,
    OrdFisGastNoDed: 70,
    OrdFisOrden: 80,

    // Constante de la tabla parametro cadena para exportacion a SAP
    Parametro_SAPServer: 'SAPServer',
    Parametro_SAPCompany: 'SAPCompany',
    Parametro_SAPTipoBD: 'SAPTipoBD',
    Parametro_SAPUserName: 'SAPUserName',
    Parametro_SAPPassword: 'SAPPassword',
    Parametro_SAPPassEncrip: 'PassEncrip',

    /*Tipo de base datos */
    listaTipoBaseDatos: [
        { value: "SQL2012", label: "SQL2012" },
        { value: "SQL2014", label: "SQL2014" },
        { value: "SQL2016", label: "SQL2016" },
        { value: "SQL2017", label: "SQL2017" },
        { value: "SQL2019", label: "SQL2019" },
        { value: "HANADB", label: "HANADB" },
    ],

    /*Estados de Catalogo X Centro Costo*/
    c_x_ccInactivo: "0",
    c_x_ccActivo: "1",
    c_x_ccBloqueado: "2",

    /* */

    ListaCatalogoXCentroCosto_Estado: [
        { value: "0", label: "INACTIVO" },
        { value: "1", label: "ACTIVO" },
        { value: "2", label: "BLOQUEADO" },

    ],

    //Definicion de Estados de Centro de Costos
    cc_Inactivo: 0,
    cc_Activo: 1,

    ListaCentroCosto_Estado: [
        { value: "0", label: "INACTIVO" },
        { value: "1", label: "ACTIVO" },
    ],

    //Tipo Referencia Centro de Utilidad
    tr_Cuenta: 1,
    tr_CentroCos: 2,


// PARA REPORTES
    listaOptionsTipoCuentas: [
        { value: 1, text: "Todas", reverso: true },
        { value: 2, text: "Tipo General", reverso: true },
        { value: 3, text: "Tipo Específico", reverso: true },
    ],
 
    listaReportesCC: [
        { value: "G", label: "Reportes de Gastos" },
        { value: "D", label: "Diario General" },
        { value: "H", label: "Histórico de Saldos"},
    ],

    listaReportesCU: [
        { value: "U", label: "Reportes de Utilidades" },
        { value: "D", label: "Diario General" },
        { value: "H", label: "Histórico de Saldos"},
    ],    

};
